import { FormControl } from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingBar from "../../../../components/LoadingBar/LoadingBar.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalCadastro from "../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import NewIcon from "../../../../components/NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../../../../components/SelectEmbarqueV2/SelectEmbarqueV2.js";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController.js";
import TabelaRedux from "../../../../contexts/Tabela.js";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import { telefoneMask } from "../../../../regex/telefoneMask.js";
import { getMotorista } from "../../../../services/ModuloGerenciador/Motorista.ts";
import { getProprietario } from "../../../../services/ModuloGerenciador/Proprietario.js";
import {
	cadastraTipoContato,
	deleteTipoContatoPorId,
	editaTipoContatoPorId,
	getTipoContato,
	getTipoContatoPorId,
} from "../../../../services/ModuloGerenciador/TipoContato.js";
import "./TipoContato.css";

const opcoes = [
	{
		opcao: "Telefone",
		valor: 1,
	},
	{
		opcao: "Email",
		valor: 2,
	},
];

function TipoContato(props) {
	const { tabelaEmpresa, profile, hasRegra } = useProfile();

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const opcoesVeiculo = opcoes.map((data) => ({
		value: data.opcao,
		label: data.opcao,
		...data,
	}));

	const labelVeiculo = (data) => <div>{data.opcao}</div>;

	const estiloVeiculo = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	const preencherDadosEditando = async (result) => {
		const tipoContatoSelecionado = opcoes.find(
			(opcao) => opcao.valor === result.tipoContatoEnum
		);
		if (tipoContatoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoContatoEnum: {
					label: tipoContatoSelecionado.opcao,
					opcao: tipoContatoSelecionado.opcao,
					valor: tipoContatoSelecionado.valor,
					value: tipoContatoSelecionado.opcao,
				},
			}));
		}
		const proprietarioSelecionado = listaProprietario.find(
			(option) => option.idProprietario === result.proprietarioId
		);
		if (proprietarioSelecionado) {
			setValuesSelect((current) => ({
				...current,
				proprietarioId: {
					value: proprietarioSelecionado.nome,
					label: proprietarioSelecionado.nome,
					id: proprietarioSelecionado.idProprietario,
				},
			}));
		}
		const motoristaSelecionado = listaMotorista.find(
			(option) => option.idMotorista === result.motoristaId
		);
		if (motoristaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				motoristaId: {
					value: motoristaSelecionado.nome,
					label: motoristaSelecionado.nome,
					id: motoristaSelecionado.idMotorista,
				},
			}));
		}
	};

	const [valuesSelect, setValuesSelect] = useState([]);

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarTipoContato = async () => {
		setLoading(true);
		await getTipoContato(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.contato !== "") {
			setLoading(true);
			await cadastraTipoContato(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarTipoContato();
						setDadosRequestControllerRedux("Fechar Modal TipoContato");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setValues({});
						setValuesSelect({});
						setTelaCadastro(false);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
					setValidator((current) => ({ ...current, contato: "true" }));
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaTipoContatoPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoContato();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setTelaCadastro(false);
					setEditando(false);
					setValues({});
					setValuesSelect({});
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarTipoContatoPorId = async () => {
		setLoading(true);
		await getTipoContatoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result.data);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarTipoContatoPorIdModal = async (id) => {
		setLoading(true);
		await getTipoContatoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarTipoContatoPorId = async () => {
		setLoading(true);
		await deleteTipoContatoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoContato();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (editando) {
			buscarTipoContatoPorId();
		}
	}, [editando]);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Uso Comum"));
			buscarTipoContato();
			buscarProprietarios();
			buscarMotorista();
			if (props.idAtual) {
				buscarTipoContatoPorIdModal(props.idAtual);
			}
		}
	}, [profile?.token, props.idAtual]);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const clearMotorista = () => {
		setValuesSelect((current) => ({ ...current, motoristaId: "" }));
		setValues((current) => ({ ...current, motoristaId: null }));
		setValidator((current) => ({ ...current, motoristaId: "false" }));
	};

	const clearProprietario = () => {
		setValuesSelect((current) => ({ ...current, proprietarioId: "" }));
		setValues((current) => ({ ...current, proprietarioId: null }));
		setValidator((current) => ({ ...current, proprietarioId: "false" }));
	};

	const buscarProprietarios = async () => {
		await getProprietario(profile?.token)
			.then((result) => {
				setListaProprietario(result.data);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarMotorista = async () => {
		await getMotorista({ token: profile?.token })
			.then((result) => {
				setListaMotorista(result.data);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const [listaProprietario, setListaProprietario] = useState([]);

	const [listaMotorista, setListaMotorista] = useState([]);

	const [idAtual, setIdAtual] = useState();

	const [loadingSelectProprietario, setLoadingSelectProprietario] =
		useState(false);

	const [openCadastroProprietario, setOpenCadastroProprietario] =
		useState(false);

	const handleCloseCadastroProprietario = (value) => {
		if (idAtual) {
			setOpenCadastroProprietario(false);
		} else {
			setLoadingSelectProprietario(true);
			buscarProprietarios();
			setOpenCadastroProprietario(false);
		}
	};

	const [loadingSelectMotorista, setLoadingSelectMotorista] = useState(false);

	const [openCadastroMotorista, setOpenCadastroMotorista] = useState(false);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Tipo Contato";
		if (telaCadastro) return "Cadastro de Tipo Contato";
		return "Tipo Contato";
	}, [editando, telaCadastro]);

	const [disable, setDisable] = useState(false);

	const isLoading = useMemo(() => {
		return loading || !profile?.token || !dadosTabela;
	}, [loading, profile?.token, dadosTabela]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
			<NavbarV3 title={title} />
			{!isLoading ? (
				<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
					{!telaCadastro ? (
						<div className="embarques">
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="id"
								nomeClasse1="outer-wrapper-cidade"
								nomeClasse2="table-wrapper-cidade-v2"
								colunas={tabelaEmpresa.TipoContato}
								dados={dadosTabela}
							/>
							<div className="container-botoes-cliente">
								<div>
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Cadastrar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setTelaCadastro(true);
											setEditando(false);
										}}
									/>
									<CustomButtonV2
										classCss="custom-button-editar"
										classText="button-texto-editar"
										titulo="Editar"
										icone="iconeEdit"
										cor="#CDCDCD"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setTelaCadastro(true);
												setEditando(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
									<CustomButtonV2
										classCss="custom-button-deletar"
										classText="button-texto-cadastrar"
										titulo="Deletar"
										icone="iconeDelete"
										cor="#DC2D2D"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setOpen(true);
												setTextoSucesso("Deletado Com Sucesso");
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								</div>
								<div>
									<CustomButtonV2
										classCss="custom-button-user"
										classText="button-texto-user"
										titulo="Obter Usuário"
										cor="#FFFFFF"
										valor={values}
										onClick={() => {
											if (tabelaRedux.usuarioAlteracao) {
												setOpenUsuario(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								</div>
							</div>
						</div>
					) : (
						<div>
							{!props.desabilitar && (
								<div className="indicadores">
									<div className="texto-cadastro">
										<p className="indicador-emb">
											{"Dados de Tipo Contato / "}
										</p>
										{editando ? (
											<p className="indicador-emb">
												{"Detalhes de Tipo Contato"}
											</p>
										) : (
											<p className="indicador-emb">
												{"Cadastro de Tipo Contato"}
											</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									<div className="close-btn">
										<CloseIcon
											onClick={() => {
												setValues({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
												setValuesSelect({});
											}}
										/>
									</div>
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Tipo Contato:
												</p>
												<FormControl sx={{ width: 265 }}>
													<Select
														value={valuesSelect.tipoContatoEnum}
														options={opcoesVeiculo}
														formatOptionLabel={labelVeiculo}
														styles={estiloVeiculo}
														placeholder="Selecione"
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	tipoContatoEnum: selectedOption.valor,
																}));
																setValuesSelect((current) => ({
																	...current,
																	tipoContatoEnum: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	tipoContatoEnum: "true",
																}));
															}
														}}
													/>
												</FormControl>
											</div>
										</div>
										<div className="coluna-emb">
											{values.tipoContatoEnum === 1 && (
												<div className="principal">
													<p className="input-label-emb" htmlFor="descricao">
														Telefone:
													</p>
													<input
														type="text"
														className="input-emb"
														style={{ width: "270px" }}
														onChange={(e) => {
															const maskedValue = telefoneMask(e.target.value); // Aplica a máscara
															setValues((current) => ({
																...current,
																contato: maskedValue,
															})); // Atualiza o estado com o valor formatado
															setValidator((current) => ({
																...current,
																contato: "true",
															})); // Mantém o validador
														}}
														placeholder=""
														value={values.contato}
														disabled={props.desabilitar}
													/>
												</div>
											)}
											{values.tipoContatoEnum === 2 && (
												<div className="principal">
													<p className="input-label-emb" htmlFor="descricao">
														Email:
													</p>
													<input
														type="text"
														className="input-emb"
														style={{ width: "270px" }}
														onChange={(e) => {
															setValues((current) => ({
																...current,
																contato: e.target.value,
															}));
															setValidator((current) => ({
																...current,
																contato: "true",
															}));
														}}
														placeholder=""
														value={values.contato}
														disabled={props.desabilitar}
													/>
												</div>
											)}
										</div>
										{!values.motoristaId && (
											<div className="coluna-emb">
												<div>
													{loadingSelectProprietario ? (
														<LoadingBar />
													) : (
														<div className="coluna-emb">
															<div className="principal">
																<p
																	className="input-label-emb"
																	htmlFor="descricao"
																>
																	Proprietário:
																</p>
																<SelectEmbarqueV2
																	classeCss={230}
																	onChange={(e) => {
																		setValuesSelect((current) => ({
																			...current,
																			proprietarioId: e,
																		}));
																		setValues((current) => ({
																			...current,
																			proprietarioId: e.id,
																		}));
																		setValidator((current) => ({
																			...current,
																			proprietarioId: "true",
																		}));
																	}}
																	onClick={(e) => {
																		e.stopPropagation();
																		setDisable(true);
																		setOpenCadastroProprietario(true);
																	}}
																	onInfoIconClick={setIdAtual}
																	id="idProprietario"
																	grande={true}
																	clearSelection={clearProprietario}
																	value={valuesSelect.proprietarioId}
																	titulo="Grupo Cliente"
																	dadosSelect={listaProprietario}
																	referenciaId="nome"
																	referenciaItem="nome"
																/>
															</div>
															<NewIcon
																onClick={(e) => {
																	setOpenCadastroProprietario(true);
																	setIdAtual(null);
																	setDisable(false);
																}}
															/>
														</div>
													)}
												</div>
											</div>
										)}
									</div>
									<div className="rota-div-2">
										{!values.proprietarioId && (
											<div className="coluna-emb">
												<div>
													{loadingSelectMotorista ? (
														<LoadingBar />
													) : (
														<div className="coluna-emb">
															<div className="principal">
																<p
																	className="input-label-emb"
																	htmlFor="descricao"
																>
																	Motorista:
																</p>
																<SelectEmbarqueV2
																	classeCss={260}
																	onChange={(e) => {
																		setValuesSelect((current) => ({
																			...current,
																			motoristaId: e,
																		}));
																		setValues((current) => ({
																			...current,
																			motoristaId: e.id,
																		}));
																		setValidator((current) => ({
																			...current,
																			motoristaId: "true",
																		}));
																	}}
																	onClick={(e) => {
																		e.stopPropagation();
																		setDisable(true);
																		setOpenCadastroMotorista(true);
																	}}
																	clearSelection={clearMotorista}
																	onInfoIconClick={setIdAtual}
																	id="idMotorista"
																	grande={true}
																	value={valuesSelect.motoristaId}
																	titulo="Grupo Cliente"
																	dadosSelect={listaMotorista}
																	referenciaId="nome"
																	referenciaItem="nome"
																/>
															</div>
															<NewIcon
																onClick={(e) => {
																	setOpenCadastroMotorista(true);
																	setIdAtual(null);
																	setDisable(false);
																}}
															/>
														</div>
													)}
												</div>
											</div>
										)}
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "255px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													value={values.nome}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Observação:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "250px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															observacao: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															observacao: "true",
														}));
													}}
													value={values.observacao}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="botoes-tipoContato">
								{editando ? (
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Salvar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											editar();
										}}
									/>
								) : (
									<>
										{!props.desabilitar ? (
											props.botaoCadastrar ? (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														if (values.contato !== "") {
															cadastrar();
														} else {
															setTextoErro("Há campos sem preencher!");
															setOpenToastErro(true);
														}
													}}
												/>
											) : (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														if (values.contato !== "") {
															cadastrar();
														} else {
															setTextoErro("Há campos sem preencher!");
															setOpenToastErro(true);
														}
													}}
												/>
											)
										) : (
											<></>
										)}
									</>
								)}
								{props.botaoVoltar ? (
									<></>
								) : (
									<CustomButtonV2
										classCss="custom-button-cancelar"
										classText="button-texto-cancelar"
										titulo="Cancelar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setValues({});
											setTelaCadastro(false);
											setEditando(false);
											setTabelaRedux({});
											setValuesSelect({});
										}}
									/>
								)}
							</div>
						</div>
					)}
					<div>
						<ModalConfirmacao
							titulo="Deletar"
							texto="Deseja Deletar?"
							tituloConfirmar="Confirmar"
							tituloCancelar="Cancelar"
							open={open}
							onClose={handleClose}
							onClick={deletarTipoContatoPorId}
						/>
						<ModalUsuario
							titulo="Usuário"
							tituloConfirmar="OK"
							open={openUsuario}
							onClose={handleCloseUsuario}
						/>
						<ModalCadastro
							titulo="Cadastro"
							tituloConfirmar="OK"
							cadastroProprietario="sim"
							open={openCadastroProprietario}
							idAtual={idAtual}
							desabilitar={disable}
							onClose={handleCloseCadastroProprietario}
						/>
					</div>
					<div>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
					</div>
				</motion.div>
			) : (
				<LoadingComponent />
			)}
		</motion.div>
	);
}

export default TipoContato;
